<app-search></app-search>
<div class="adaptive-grow-1">
  <div class="fluent-container">
    <br />
    <div class="title-color">
      <h1 class="title">Lista de {{ termKey.AccompanimentServicePlural | term }}</h1>
    </div>
    <br />
    <div class="card-header">
      <button
        id=""
        class="primary-button"
        appPermision="/assistanceservice+c"
        (click)="createAssistanceService()"
      >
        <span class="button-content"> <mat-icon>add_circle</mat-icon> Agregar nuevo </span>
      </button>
    </div>
    <br />
    <div class="table-scroll-wrapper">
      <section class="table-container mat-elevation-z1" tabindex="0">
        <div class="table-adjustable">
          <table
            mat-table
            multiTemplateDataRows
            [dataSource]="
              (asyncassistanceservice | async) ?? []
                | paginate
                  : {
                      id: 'server',
                      itemsPerPage: limit,
                      currentPage: page,
                      totalItems: total,
                    }
            "
          >
            <ng-container matColumnDef="acciones">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let assistanceService">
                <a
                  mat-icon-a
                  (click)="toggleActivities(assistanceService)"
                  [attr.aria-label]="
                    isExpanded(assistanceService.id) ? 'Ocultar actividades' : 'Ver actividades'
                  "
                >
                  <mat-icon class="main-icon">{{
                    isExpanded(assistanceService.id) ? 'expand_less' : 'chevron_right'
                  }}</mat-icon>
                </a>
                <a
                  mat-icon-a
                  [matMenuTriggerFor]="serviceMenu"
                  aria-label="Acciones"
                  title="Acciones"
                >
                  <mat-icon class="main-icon">menu</mat-icon>
                </a>
                <mat-menu #serviceMenu="matMenu" class="icon-menu">
                  <button
                    mat-menu-item
                    appPermision="/assistanceservice+u"
                    (click)="updateAssistanceService(assistanceService)"
                  >
                    <span class="text-span"
                      ><mat-icon class="icon-size">edit</mat-icon> Editar
                      {{ termKey.AccompanimentServiceSingular | term }}</span
                    >
                  </button>
                  <button
                    mat-menu-item
                    appPermision="/serviceactivity+c"
                    (click)="addActivity(assistanceService)"
                  >
                    <span class="text-span"
                      ><mat-icon class="icon-size">add_circle</mat-icon> Agregar
                      {{ termKey.ActivityServiceSingular | term }}</span
                    >
                  </button>
                  <mat-divider></mat-divider>
                  <button
                    mat-menu-item
                    appOnlysuperuser="/assistanceservice"
                    (click)="eliminate(assistanceService)"
                  >
                    <span class="text-span delete-span"
                      ><mat-icon class="icon-size delete-span">delete</mat-icon> Eliminar
                      {{ termKey.AccompanimentServiceSingular | term }}</span
                    >
                  </button>
                </mat-menu>
              </td>
            </ng-container>

            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>ID</th>
              <td mat-cell *matCellDef="let assistanceService">
                {{ assistanceService.id }}
              </td>
            </ng-container>

            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>Nombre</th>
              <td mat-cell *matCellDef="let assistanceService">
                {{ assistanceService.name }}
              </td>
            </ng-container>

            <ng-container matColumnDef="components">
              <th mat-header-cell *matHeaderCellDef>Componentes</th>
              <td mat-cell *matCellDef="let assistanceService">
                {{ assistanceService.components?.name }}
              </td>
            </ng-container>

            <ng-container matColumnDef="humanResources">
              <th mat-header-cell *matHeaderCellDef>Cargo</th>
              <td mat-cell *matCellDef="let assistanceService">
                @if (assistanceService.humanResources?.length) {
                  <ul>
                    @for (hr of assistanceService.humanResources; track hr.id) {
                      @for (e of hr.employee; track e.id) {
                        <li>{{ e.name }} - {{ e.relationshipType }} - {{ e.monthSalary }}</li>
                      }
                    }
                  </ul>
                } @else {
                  <span>No registra</span>
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="infraestructure">
              <th mat-header-cell *matHeaderCellDef>Infraestructura</th>

              <td mat-cell *matCellDef="let assistanceService">
                @if (assistanceService.infraestructure?.length) {
                  <ul class="m-0 ps-3">
                    @for (infra of assistanceService.infraestructure; track infra.id) {
                      @for (i of infra.infraestructure; track i.id) {
                        <li>{{ i.name }} - {{ i.type }}</li>
                      }
                    }
                  </ul>
                } @else {
                  <span>No registra</span>
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="fixedAsset">
              <th mat-header-cell *matHeaderCellDef>{{ termKey.FixedAssetPlural | term }}</th>

              <td mat-cell *matCellDef="let assistanceService">
                @if (assistanceService.fixedAsset?.length) {
                  <ul class="m-0 ps-3">
                    @for (fixed of assistanceService.fixedAsset; track fixed.id) {
                      @for (fa of fixed.fixedAsset; track fa.id) {
                        <li>{{ fa.name }} - {{ fa.description }}</li>
                      }
                    }
                  </ul>
                } @else {
                  <span>No registra</span>
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="locations">
              <th mat-header-cell *matHeaderCellDef>Ubicación</th>

              <td mat-cell *matCellDef="let assistanceService">
                @if (assistanceService.locations?.length) {
                  <ul>
                    @for (lo of assistanceService.locations; track lo) {
                      <li>{{ lo.city }} - {{ lo.department }}</li>
                    }
                  </ul>
                } @else {
                  <span>No registra</span>
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="lifePlan">
              <th mat-header-cell *matHeaderCellDef>Plan de vida</th>

              <td mat-cell *matCellDef="let assistanceService">
                @if (assistanceService.lifePlan?.length) {
                  <ul>
                    @for (lp of assistanceService.lifePlan; track lp) {
                      <li>{{ lp.name }}</li>
                    }
                  </ul>
                } @else {
                  <span>No registra</span>
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="territory">
              <th mat-header-cell *matHeaderCellDef>Territorio</th>

              <td mat-cell *matCellDef="let assistanceService">
                @if (assistanceService.territory?.length) {
                  <ul>
                    @for (t of assistanceService.territory; track t) {
                      <li>{{ t.name }}</li>
                    }
                  </ul>
                } @else {
                  <span>No registra</span>
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="total">
              <th mat-header-cell *matHeaderCellDef>Total</th>
              <td mat-cell *matCellDef="let assistanceService">
                {{ assistanceService.total }}
              </td>
            </ng-container>

            <ng-container matColumnDef="activitiesDetail">
              <td mat-cell *matCellDef="let assistanceService" [attr.colspan]="showColumns.length">
                @if (isExpanded(assistanceService.id)) {
                  <app-assistanceservice-serviceactivity-list
                    [service]="assistanceService"
                    (changed)="fetchAssistanceServices(page)"
                  ></app-assistanceservice-serviceactivity-list>
                }
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="showColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: showColumns" class="highlight-row"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: ['activitiesDetail']"
              class="activities-detail-row"
            ></tr>
          </table>
        </div>
      </section>
    </div>
    <pagination-controls
      (pageChange)="fetchAssistanceServices($event)"
      previousLabel="Anterior"
      nextLabel="Siguiente"
      id="server"
    ></pagination-controls>
  </div>
</div>
